import { add, listen, qs, qsa } from "@fluorescent/dom";
import { section } from "@/neon";
import { on, emit } from "@/neon/events";

import { syncTabIndexesOnFlickity } from "@/lib/a11y";

const sel = {
  arrow: ".mobile-carousel__pagination-arrow",
  slide: "[data-js-slide]",
  slider: "[data-js-slider]",
  next: "[data-js-next]",
};

section("carousel", {
  events: [],
  carousel: null,

  onLoad() {
    const slider = qs(sel.slider, this.container);
    const arrows = qsa(sel.arrow, this.container);
    const previousButton = qs("[data-prev]", this.container);
    const nextButton = qs("[data-next]", this.container);

    // Show pagination arrows
    add(arrows, "visible");

    const setHeight = () => {
      const first = qs(".carousel__slide .carousel__image", this.container);
      if (!first) return;

      this.container.style.setProperty(
        "--height-carousel",
        first.offsetHeight + "px"
      );
    };

    // Set the mobile height within the Shopify Editor > Section Visual Preview to prevent CLS
    if (window.Shopify.visualPreviewMode === true) {
      this.container.style.setProperty("--height-carousel-mobile", "400px");
    }

    import(flu.chunks.flickity).then(({ Flickity }) => {
      this.carousel = new Flickity(slider, {
        adaptiveHeight: false,
        cellSelector: sel.slide,
        pageDots: false,
        prevNextButtons: false,
        setGallerySize: false,
        wrapAround: true,
        on: {
          ready: () => {
            var carousel = Flickity.data(slider); // This is a pain but we can't access the instance within here
            setHeight();
            syncTabIndexesOnFlickity(carousel);
          },
        },
      });

      this.carousel.on("resize", () => setHeight());

      this.carousel.on("change", () => {
        syncTabIndexesOnFlickity(this.carousel);
      });

      this.prevClick = listen(previousButton, "click", () =>
        this.carousel.previous()
      );
      this.nextClick = listen(nextButton, "click", () => this.carousel.next());

      emit("carousel:initialized");
    });
  },

  onUnload() {
    this.carousel && this.carousel.destroy();
    if (this.carousel && (this.carousel.slides || {}).length > 1) {
      this.prevClick();
      this.nextClick();
    }
  },

  onBlockSelect({ target }) {
    this.flkty && this.flkty.select(target.dataset.index);
  },

  onBlockSelect({ target }) {
    if (this.carousel) {
      this._handleBlockSelect(target.dataset.index);
    } else {
      // Listen for initalization if carousel does not exist
      this.events.push(
        on("carousel:initialized", () => {
          this._handleBlockSelect(target.dataset.index);
        })
      );
    }
  },

  onBlockDeselect() {
    if (this.carousel) {
      this._unpause();
    } else {
      // Listen for initalization if carousel does not exist
      this.events.push(
        on("carousel:initialized", () => {
          this._unpause();
        })
      );
    }
  },

  _handleBlockSelect(slideIndex) {
    this.carousel.select(slideIndex);
    this._pause();
  },

  _pause() {
    this.carousel && this.carousel.pausePlayer();
  },

  _unpause() {
    this.carousel && this.carousel.unpausePlayer();
  },
});
